<template>
    <section class="preview">

        <div>
        <template>

        <CContainer>
        <CModal
          color="primary"
          :show.sync="modalGallery"
          class="text-center"
          style="z-index:10000"
          @close="modalGallery = false"
          size="xl"
          name="modalGallery"
        >
         
            <mdbModalHeader center :close="false" slot="header">
              <p
                class="heading"
              >Crear Backgroundd image</p>
            </mdbModalHeader>
            <form novalidate @submit.prevent="crearGallery">
            <CModal-body>
              <div class="row text-left">
                        <div class="col-6">
                        <label class="typo__label">Titulo de pagina</label>
                        <mdb-input
                                class="mb-3 mt-0"
                                v-model="gallery.title"
                                required
                                invalidFeedback="Coloca un texto"
                            ></mdb-input>
                        </div>

                        <div class="col-6">
                            <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                Imagenes
                                </label>
                                <multiselect
                                v-model="gallery.image_id"
                                placeholder="Seleccione una opcion"
                                label="name"
                                track-by="id"
                                :options="image_ids"
                                :multiple="false"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="row text-left">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Texto debajo de la imagen</label>
                                <textarea
                                class="form-control"
                                rows="2"
                                v-model="gallery.text_under_image"
                            ></textarea>
                            </div>
                        </div>
                    </div>

            </CModal-body>
            
        </form>
         <CModal-footer center slot="footer">
              <CButton color="secondary" size="sm" @click="modalGallery = false">Cerrar</CButton>
              <CButton color="primary" :disabled="isLoadingGallery">
                <span v-if="!isLoadingGallery">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingGallery"
                    ></semipolar-spinner>
                </CButton>
            </CModal-footer>
        </CModal>
      </CContainer>
    </template>


           <!--  <mdb-modal fullHeight position="top" :show="modalGallery" @close="modalGallery = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Crear Background image</mdb-modal-title>
                </mdb-modal-header>
                <form novalidate @submit.prevent="crearGallery">
                <mdb-modal-body>

                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Titulo de pagina"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="gallery.title"
                                required
                                invalidFeedback="Coloca un texto"
                            ></mdb-input>
                        </div>

                        <div class="col-6">
                            <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                Imagenes
                                </label>
                                <multiselect
                                v-model="gallery.image_id"
                                placeholder="Seleccione una opcion"
                                label="name"
                                track-by="id"
                                :options="image_ids"
                                :multiple="false"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Texto debajo de la imagen</label>
                                <textarea
                                class="form-control"
                                rows="2"
                                v-model="gallery.text_under_image"
                            ></textarea>
                            </div>
                        </div>
                    </div>

                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn color="secondary" @click.native="modalGallery = false">Cerrar</mdb-btn>
                    <mdb-btn type="submit" color="primary" :disabled="isLoadingGallery">
                    <span v-if="!isLoadingGallery">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingGallery"
                    ></semipolar-spinner>
                    </mdb-btn>
                </mdb-modal-footer>
                </form>
            </mdb-modal>
 -->


         <CContainer>
        <CModal
          color="primary"
          :show.sync="modalColor"
          class="text-center"
          style="top:40px;"
          @close="modalColor = false"
          size="sm"
        >

            <CModal-body>
              <color-picker
                        :style="{width: '220px', left: '10px', position:'relative'}"
                        :color="selected_color"
                        :sucker-hide="false"
                        :sucker-canvas="suckerCanvas"
                        :sucker-area="suckerArea"
                        @changeColor="changeColor"
                        @openSucker="openSucker"
                    />
            </CModal-body>
            
            <CModal-footer center slot="footer">
              <CButton color="primary" size="sm" @click="modalColor = false">Cerrar</CButton>
            </CModal-footer>
        </CModal>
      </CContainer>

           <!--  <mdb-modal size="sm" :show="modalColor" @close="modalColor = false">
                <mdb-modal-body>
                    <color-picker
                        :style="{width: '220px', left: '10px', position:'relative'}"
                        :color="selected_color"
                        :sucker-hide="false"
                        :sucker-canvas="suckerCanvas"
                        :sucker-area="suckerArea"
                        @changeColor="changeColor"
                        @openSucker="openSucker"
                    />
                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn color="primary" size="sm" @click.native="modalColor = false">Cerrar</mdb-btn>
                </mdb-modal-footer>
            </mdb-modal> -->
        </div>

        <div class="text-left">

             <CContainer>
        <CModal
          color="primary"
          :show.sync="modalBackground"
          class="text-center"
          style="top:40px;z-index:9999"
          @close="modalBackground = false"
          size="xl"
        >
        <CModal-header center :close="false" slot="header">
              <p
                class="heading"
              >Crear Background image</p>
            </CModal-header>
            <CModalBody>
             <div class="row text-left">
                        <div class="col-6">
                        <label class="typo__label">Nombre de images</label>
                        <mdb-input
                                class="mb-3 mt-0"
                                v-model="background.name"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleFormControlFile1">Suba la imagen</label>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    id="file-background"
                                    multiple
                                    accept=".png, .jpg, .jpeg"
                                    @change="previewFiles()"
                                />
                                </div>
                        </div>
                    </div>
                    <div class="row text-left">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Descripcion</label>
                                <textarea
                                class="form-control"
                                rows="8"
                                v-model="background.description"
                            ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row text-left">
                        <div class="col-6">
                        <label class="typo__label">Loader image</label>
                        <mdb-input
                                class="mb-3 mt-0"
                                v-model="background.loader_image"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                    Gallery ids
                                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalGallery = true; modalBackground = false"></i>
                                </label>
                                <multiselect
                                v-model="background.gallery_ids"
                                placeholder="Seleccione una opcion"
                                label="title"
                                track-by="id"
                                :options="gallery_ids"
                                :multiple="true"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                    </div>
            </CModalBody>
            
            <CModal-footer center slot="footer" >
              <CButton color="secondary"  class="p-2 mt-2 "  @click="modalBackground = false">Cerrar</CButton>
              <CButton color="primary"  class="p-2 mt-2 " type="submit"   :disabled="isLoadingBackground"> 
                <span v-if="!isLoadingBackground">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingBackground"
                    ></semipolar-spinner>
                </CButton>
            </CModal-footer>
        </CModal>
      </CContainer>
<!-- 
            <mdb-modal fullHeight position="top" :show="modalBackground" @close="modalBackground = false">
                <mdb-modal-header>
                <mdb-modal-title>Crear Background image</mdb-modal-title>
                </mdb-modal-header>
                <form novalidate @submit.prevent="crearBackground">
                <mdb-modal-body>
                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Nombre de images"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="background.name"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="exampleFormControlFile1">Suba la imagen</label>
                                <input
                                    type="file"
                                    class="form-control-file"
                                    id="file-background"
                                    multiple
                                    accept=".png, .jpg, .jpeg"
                                    @change="previewFiles()"
                                />
                                </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <label class="typo__label">Descripcion</label>
                                <textarea
                                class="form-control"
                                rows="8"
                                v-model="background.description"
                            ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                        <mdb-input
                                label="Loader image"
                                class="mb-3 mt-0"
                                style="padding-top:25px"
                                v-model="background.loader_image"
                                required
                                invalidFeedback="Coloca el titulo"
                            ></mdb-input>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label class="typo__label">
                                    Gallery ids
                                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalGallery = true"></i>
                                </label>
                                <multiselect
                                v-model="background.gallery_ids"
                                placeholder="Seleccione una opcion"
                                label="title"
                                track-by="id"
                                :options="gallery_ids"
                                :multiple="true"
                                :taggable="true"
                                ></multiselect>
                            </div>
                        </div>
                    </div>
                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn color="secondary" @click.native="modalBackground = false">Cerrar</mdb-btn>
                    <mdb-btn type="submit" color="primary" :disabled="isLoadingBackground">
                    <span v-if="!isLoadingBackground">Crear</span>
                    <semipolar-spinner
                        :animation-duration="2000"
                        :size="30"
                        color="#ffffff"
                        v-if="isLoadingBackground"
                    ></semipolar-spinner>
                    </mdb-btn>
                </mdb-modal-footer>
                </form>
            </mdb-modal> -->
        </div>

        <div>

         <CContainer>
            <CModal
              color="primary"
              :show.sync="modalGallerySelect"
              class="text-center"
              style="top:40px;z-index:10000"
              @close="modalGallerySelect = false"
              size="xl"
            >
            <CModal-header center :close="false" slot="header">
              <p
                class="heading"
              >Seleccionar Background</p>
            </CModal-header>
                <CModal-body>
                    <div class="row">
                        <vue-select-image :dataImages="loader_images_gallery"
                                        h = "100px"
                                        @onselectimage="onSelectImage">
                        </vue-select-image>
                    </div>
                </CModal-body>
                
                <CModal-footer center slot="footer">
                  <CButton color="primary" type="submit" size="sm" @click="modalGallerySelect = false"> <span>Seleccionar</span></CButton>
                </CModal-footer>
            </CModal>
          </CContainer>

            <!-- <mdb-modal fullHeight position="top" :show="modalGallerySelect" @close="modalGallerySelect = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Seleccionar Background</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>
                    <div class="row">
                        <vue-select-image :dataImages="loader_images_gallery"
                                        h = "100px"
                                        @onselectimage="onSelectImage">
                        </vue-select-image>
                    </div>
                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn type="submit" color="primary" @click="modalGallerySelect = false">
                        <span>Seleccionar</span>
                    </mdb-btn>
                </mdb-modal-footer>
            </mdb-modal> -->
        </div>

        <div>
            <CContainer>
                <CModal
                  color="primary"
                  :show.sync="modalImageSelectQuestion"
                  class="text-center"
                  style="top:40px;z-index:10000"
                  @close="modalImageSelectQuestion = false"
                  size="xl"
                >
                <CModal-header center :close="false" slot="header">
                  <p
                    class="heading"
                  >Seleccionar imagen</p>
                </CModal-header>
                    <CModal-body>
                        <div class="row">
                            <vue-select-image :dataImages="loader_images_gallery"
                                            h = "100px"
                                            @onselectimage="onSelectImageQuestion">
                            </vue-select-image>
                        </div>
                    </CModal-body>
                    
                    <CModal-footer center slot="footer">
                      <CButton color="primary" type="submit" size="sm" @click="modalImageSelectQuestion = false"> <span>Seleccionar</span></CButton>
                    </CModal-footer>
                </CModal>
              </CContainer>
            <!-- <mdb-modal fullHeight position="top" :show="modalImageSelectQuestion" @close="modalImageSelectQuestion = false" style="z-index:10000">
                <mdb-modal-header>
                <mdb-modal-title>Seleccionar imagen</mdb-modal-title>
                </mdb-modal-header>
                <mdb-modal-body>
                    <div class="row">
                        <vue-select-image :dataImages="loader_images_gallery"
                                        h = "100px"
                                        @onselectimage="onSelectImageQuestion">
                        </vue-select-image>
                    </div>
                </mdb-modal-body>
                <mdb-modal-footer>
                    <mdb-btn type="submit" color="primary" @click="modalImageSelectQuestion = false">
                        <span>Seleccionar</span>
                    </mdb-btn>
                </mdb-modal-footer>
            </mdb-modal> -->
        </div>

        <div class="row" v-if="!isLoading">
            <div class="col-7 text-left">
                <form-wizard
                    @on-complete="onComplete"
                    shape="circle"
                    color="#20a0ff"
                    error-color="#ff4949"
                    title="Nueva Quiz/Gallery"
                    subtitle="Paso a paso"
                    >
                        <tab-content title="Datos básicos" icon="fas fa-tasks"  >
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="typo__label">Dominio</label>
                                        <multiselect
                                        v-model="domain_id"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="id"
                                        :options="domain_ids"
                                        :multiple="false"
                                        :taggable="true"

                                        ></multiselect>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="typo__label">Tipo de Quiz</label>
                                        <multiselect
                                        v-model="quiz_type"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="value"
                                        :options="quiz_types"
                                        :multiple="false"
                                        :taggable="true"
                                        ></multiselect>
                                    </div>
                                </div>
                                 <div class="col-6" v-if="quiz_type.value=='questions'">
                                    <div class="form-group">
                                        <label class="typo__label">Modelo de Quiz</label>
                                        <multiselect
                                        v-model="quiz_model"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="value"
                                        :options="quiz_models"
                                        :multiple="false"
                                        :taggable="true"
                                        ></multiselect>
                                    </div>
                                </div> 

                              </div>

                            <div class="row">
                              <!-- <div class="col-6">

                                <mdb-input
                                        label="Modelo de Quiz"
                                        class="mb-3 mt-0"
                                        style="padding-top:25px"
                                        v-model="model"
                                        required
                                    ></mdb-input>
                                </div> -->
                            
                                <div class="col-12">

                                <label class="typo__label">URL de redireccion al completar el quiz</label>
                    
                                <mdb-input
                                        
                                        class="mb-3 mt-0"
                                        v-model="url_quiz_completion_id"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                    ></mdb-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                <label class="typo__label">slug</label>
                                <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="slug2"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                    ></mdb-input>
                                </div>

                                <div class="col-6">
                                <label class="typo__label">Subtitulo</label>
                                <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="subtitle"
                                        required
                                        invalidFeedback="Coloca el titulo"
                                    ></mdb-input>
                                </div>
                            </div>

                            <div class="row">



                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="typo__label">Partner</label>
                                        <multiselect
                                        v-model="partner_id"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="id"
                                        :options="partner_ids"
                                        :multiple="false"
                                        :taggable="true"
                                        ></multiselect>
                                    </div>
                                </div>
                            
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="typo__label">Pais</label>
                                        <multiselect
                                        v-model="country_id"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="id"
                                        :options="country_ids"
                                        :multiple="false"
                                        :taggable="true"
                                        ></multiselect>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group" style="padding-top:25px">
                                        <CInputCheckbox
                                            v-model="pre_redirect"
                                            name="checkbox-5"
                                            label="Redireccionar luego del primer click"
                                        />
                                    </div>
                                </div>

                                <div class="col-6">
                                <label class="typo__label">Query</label>
                                <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="query"
                                        required
                                        invalidFeedback="Coloca un query"
                                    ></mdb-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="typo__label">Loader image</label>
                                        <!--<multiselect
                                        v-model="image_id"
                                        placeholder="Seleccione una opcion"
                                        label="name"
                                        track-by="id"
                                        :options="loader_images"
                                        :multiple="false"
                                        :taggable="true"
                                        ></multiselect>-->
                                        <div class="row">
                                            <mdb-btn type="submit" color="primary" @click="openModalGallery('image_id')">
                                                <span v-if="!isLoadingGallery">{{background_img.alt?background_img.alt:"Select Background image"}}</span>
                                            </mdb-btn>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6">
                                <label class="typo__label">Loader time/secons</label>
                                <mdb-input
                                        class="mb-3 mt-0"
                                        v-model="loader_time"
                                        required
                                        invalidFeedback="Coloca un loader"
                                    ></mdb-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="typo__label">HTML head analytics</label>
                                        <textarea
                                        class="form-control"
                                        rows="8"
                                        v-model="html_head_analytics"
                                    ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="typo__label">HTML body analytics</label>
                                        <textarea
                                        class="form-control"
                                        rows="8"
                                        v-model="html_body_analytics"
                                    ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-12">
                                    <label class="typo__label">
                                        HTML debajo de respuestas

                                        </label>
                                    <vue-editor v-model="html_under_answer"></vue-editor>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label class="typo__label">
                                            Background image
                                            <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                        </label>
                                        <div class="row">
                                            <mdb-btn type="submit" color="primary" @click="openModalGallery('background_img')">
                                                <span v-if="!isLoadingGallery">{{background_img.alt?background_img.alt:"Select Background image"}}</span>
                                            </mdb-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab-content>
                        <tab-content :title="quiz_type.value=='gallery'?'Galeria':(quiz_type.value=='questions' || quiz_type.value=='test' ) ?'Pregunta':'Pregunta'" icon="fas fa-photo"  >
                            <div v-if="quiz_type.value=='gallery'">
                                <div v-for="(quizGallery,index) in questions_gallery_ids" :key="index">
                                    <div class="row" >
                                        <div class="col-12">
                                        <label class="typo__label">Nombre</label>
                                            <mdb-input
                                                    class="mb-3 mt-0"
                                                    v-model="quizGallery.name"
                                                    required
                                                    invalidFeedback="Coloca el titulo"
                                                >
                                            </mdb-input>
                                        </div>
                                        <!-- <div class="col-6">
                                        <label class="typo__label">Question Type</label>
                                            <multiselect
                                                v-model="question.question_type"
                                                placeholder="Seleccione una opcion"
                                                label="name"
                                                track-by="id"
                                                :options="question_types"
                                                :multiple="false"
                                                :taggable="true"
                                            ></multiselect>
                                        </div>-->
                                       
                                    </div>

                                    <div class="row">
                                        <div class="col-4 offset-4 text-center">
                                            <h5>Paginas de galleria</h5>
                                        </div>
                                    </div>

                                    <div class="row" v-for="(page,i) in quizGallery.page_ids" :key="index+'-'+i">
                                        <div class="col-3">
                                        <label class="typo__label">Título de la página</label>
                                            <mdb-input
                                                    class="mb-3 mt-0"
                                                    v-model="page.title"
                                                    required
                                                    invalidFeedback="Coloca el titulo"
                                                >
                                            </mdb-input>
                                        </div>

                                        <div class="col-3">
                                            <div class="form-group">
                                            <label class="typo__label">
                                                Imagen
                                                <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                            </label>
                                            <multiselect
                                            v-model="page.image_id"
                                            placeholder="Seleccione una opcion"
                                            label="name"
                                            track-by="id"
                                            :options="loader_images"
                                            :multiple="false"
                                            :taggable="true"
                                            ></multiselect>
                                        </div>
                                        </div>

                                        <div class="col-3">
                                        <label class="typo__label">Texto debajo de la imagen</label>
                                            <mdb-input
                                                    class="mb-3 mt-0"
                                                    v-model="page.text_under_image"
                                                    required
                                                    invalidFeedback="Coloca el titulo"
                                                >
                                            </mdb-input>
                                        </div>
                                        <div class="col-3 pt-3">
                                            <div class="row">
                                                
                                                <div class="col-6">
                                                    <mdb-btn color="danger" @click="removePage(i,index)">
                                                        Eliminar
                                                    </mdb-btn>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class ="col-2 offset-5 text-center">
                                            <mdb-btn @click="addPage(index)" color="success">
                                            Agregar
                                            </mdb-btn>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group" style="padding-top:25px">
                                                <CInputCheckbox
                                                label="Publicar esta galeria"
                                                v-model="quizGallery.publish"
                                                name="checkbox-4"
                                                />
                                                 
                                            </div>
                                        </div>
                                    </div>
                                    <div class ="offset-8 col-4" v-if="questions_gallery_ids.length > 1">
                                        <mdb-btn @click="deleteQuestionGalery(index)" color="danger">
                                        Eliminar ultimo Question Gallery
                                        </mdb-btn>
                                    </div>
                                    <div class="border-top my-3" :style="{ borderTop: '5px solid #ccc', }"></div>
                                </div>
                                <div class="row">
                                    <div class ="col-4" >
                                        <mdb-btn @click="addQuestionGalery()" color="success">
                                        Agregar Question Gallery
                                        </mdb-btn>
                                    </div>

                                </div>

                            </div>
                            <div v-else>
                                <div class="" v-for="(question,index_general) in questions" :key="index_general+'-question'">
                                    <div class="row">
                                        <div class="col-6">
                                        <label class="typo__label">Pregunta</label>
                                            <mdb-input
                                                    class="mb-3 mt-0"
                                                    v-model="question.question_text"
                                                    required
                                                    invalidFeedback="Coloca el titulo"
                                                >
                                            </mdb-input>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <!--<label class="typo__label">
                                                    Imagen
                                                    <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                                </label>
                                                <multiselect
                                                v-model=""
                                                placeholder="Seleccione una opcion"
                                                label="name"
                                                track-by="id"
                                                :options="loader_images"
                                                :multiple="false"
                                                :taggable="true"
                                                ></multiselect>-->
                                                <div class="form-group">
                                                    <label class="typo__label">
                                                        Imagen
                                                        <i class="fas fa-plus-circle icono-crear mr-1" @click="modalBackground = true"></i>
                                                    </label>
                                                    <div class="row">
                                                        <mdb-btn type="submit" color="primary" @click="openModalGalleryQuestion(index_general)">
                                                                {{question.image_id.alt?question.image_id.alt:"Select image"}}
                                                        </mdb-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="typo__label">
                                                    Tipo de pregunta
                                                </label>
                                                <multiselect
                                                v-model="question.question_type"
                                                placeholder="Seleccione una opcion"
                                                label="name"
                                                track-by="value"
                                                :options="question_types"
                                                :multiple="false"
                                                :taggable="true"
                                                ></multiselect>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="question.question_type.value=='multi_choice'">
                                        <div class="row mb-4" >
                                            <div class="col-4 offset-4 text-center">
                                                <h5 >Opcion multiple</h5>
                                            </div>
                                        </div>


                                        <div class="row" v-for="(option,index) in question.question_options" :key="index">
                                            <div class="col-4">
                                            <label class="typo__label">Opcion</label>
                                            <mdb-input
                                                        class="mb-3 mt-0"
                                                        v-model="option.question_text"
                                                        required
                                                        invalidFeedback="Coloca el titulo"
                                                    >
                                                </mdb-input>
                                            </div>

                                            <div class="col-2">
                                                <div class="form-group" style="padding-top:25px">
                                                    <CInputCheckbox
                                                    label="Correcto"
                                                    v-model="option.correct"
                                                    name="checkbox-1"
                                                    ></CInputCheckbox>
                                                </div>
                                            </div>
                                            <div class="col-3">
                                                <div class="form-group">
                                                <label class="typo__label">number</label>
                                            
                                                    <mdb-input
                                                        label="Valor"
                                                        class="mb-3 mt-0"
                                                        v-model="option.value"
                                                        required
                                                    >
                                                </mdb-input>
                                                </div>
                                            </div>

                                            <div class="col-3 pt-3">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <mdb-btn color="danger" @click="removeQuestion(index_general,index)">
                                                            Eliminar
                                                        </mdb-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class ="col-4 offset-4 text-center" >
                                                <mdb-btn @click="addQuestion(index_general)" color="success">
                                                Agregar opcion
                                                </mdb-btn>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="question.question_type.value=='fill_blank'">
                                        
                                        <div class="row" v-for="(option,index) in question.question_options" :key="index">
                                            <div class="col-4">
                                            <mdb-input
                                                        class="mb-3 mt-0"
                                                        v-model="option.question_text"
                                                        required
                                                        invalidFeedback="Coloca el titulo"
                                                    >
                                                </mdb-input>
                                            </div>

                                            <div class="col-3 ">
                                                <div class="row">
                                                    <div class="col-3">
                                                        <mdb-btn color="danger" @click="removeQuestion(index_general,index)">
                                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                                        </mdb-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class ="col-4 offset-4 text-center" >
                                                <mdb-btn @click="addQuestion(index_general)" color="success">
                                                    Agregar registro
                                                </mdb-btn>
                                            </div>
                                        </div>
                                    </div>


                                </div>


                                <div class="row">
                                    <div class ="col-4" >
                                        <mdb-btn @click="addQuestionGeneral()" color="success">
                                        Agregar Pregunta
                                        </mdb-btn>
                                    </div>
                                </div>
                            </div>
                        </tab-content>
                        <tab-content title="Estilos CSS" icon="fab fa-css3"  >
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo General</h5>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('css_page_background')">
                                            <label class="typo__label">Background page css</label>
                                            <mdb-input
                                                class="mb-3 mt-0"
                                                v-model="css_page_background"
                                                required
                                                invalidFeedback="Coloca el titulo"
                                            >
                                            </mdb-input>
                                            <div :style="{height: '20px',width: '20px',background: css_page_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('css_top_bar')">
                                        <label class="typo__label">top bar css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="css_top_bar"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >

                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: css_top_bar,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('css_top_bar_color')">
                                        <label class="typo__label">top bar color css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="css_top_bar_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: css_top_bar_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo de Titulo</h5>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('title_background')">
                                        <label class="typo__label">Background titulo css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="title_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: title_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('title_font_color')">
                                        <label class="typo__label">Color de titulo css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="title_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: title_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4" >
                                        <label class="typo__label">Font size de titulo</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="title_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo de subtitulo</h5>
                                    </div>
                                    <div class="col-6"  @click="openColorModal('subtitle_font_color')">
                                        <label class="typo__label">Color de subtitulo css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: subtitle_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-6">
                                        <label class="typo__label">Font size subtitulo css</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilos Question</h5>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('question_background')">
                                        <label class="typo__label">Background question</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="question_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: question_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('question_font_color')">
                                        <label class="typo__label">Color de fuente Question</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="question_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: question_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4">
                                        <label class="typo__label">Font size de Question</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="question_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilos Opciones</h5>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('option_background')">
                                        <label class="typo__label">Background opcion</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="option_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: option_background,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('option_font_color')">
                                        <label class="typo__label">Color de fuente Opcion</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="option_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                        <div :style="{height: '20px',width: '20px',background: option_font_color,borderRadius: '10px',position: 'absolute',top: '35px',left: '50%', border: '1px solid black'}"></div>
                                    </div>
                                    <div class="col-4">
                                        <label class="typo__label">Font size de Opcion</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="option_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>
                        </tab-content>
                        <tab-content title="Pagina de confirmacion" icon="fas fa-file-code"  >
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group" style="padding-top:25px">
                                        <CInputCheckbox
                                            v-model="show_confirmation"
                                            name="checkbox-2"
                                            label="Mostrar preguntas luego de la confirmacion"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <label class="typo__label">Head confirmacion</label>
                                    <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="heading_confirmation"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                    </mdb-input>
                                </div>
                                <div class="col-6">
                                    <label class="typo__label">Subtitulo confirmacion</label>
                                    <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_confirmation"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                    </mdb-input>
                                </div>
                            </div>
                            <div class="row">
                                    <div class="col-12">
                                    <div class="form-group">
                                        <label class="typo__label">Imagen de confirmacion</label>
                                        <div class="row">
                                            <mdb-btn type="submit" color="primary" @click="openModalGallery('confirmmation_image_id')">
                                                <span v-if="!isLoadingGallery">{{confirmmation_image_id.alt?confirmmation_image_id.alt:"Select Background image"}}</span>
                                            </mdb-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-12">
                                    <label class="typo__label">Html codigo de confirmacion</label>
                                    <textarea
                                        class="form-control"
                                        rows="8"
                                        v-model="html_code_confirmation"
                                    ></textarea>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <label class="typo__label">
                                        codigo HTML de boton de confirmacion

                                    </label>
                                    <vue-editor v-model="html_button_code_confirmation"></vue-editor>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group" style="padding-top:25px">
                                        <CInputCheckbox
                                            label="Mostrar pagina de confirmacion luego de la ultima pregunta(question)"
                                            v-model="show_confirmation_last_page"
                                            name="checkbox-3"
                                        />

                                    </div>
                                </div>
                            </div>

                        </tab-content>
                        <tab-content title="Pagina CSS" icon="fab fa-css3"  >
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo General</h5>
                                    </div>
                                    <div class="col-6">
                                        <label class="typo__label">Imagen de background</label>
                                        <div class="row">
                                            <mdb-btn type="submit" color="primary" @click="openModalGallery('page_background_confirmation_img')">
                                                <span v-if="!isLoadingGallery">{{page_background_confirmation_img.alt?page_background_confirmation_img.alt:"Select Background image"}}</span>
                                            </mdb-btn>
                                        </div>
                                    </div>
                                    <div class="col-6" @click="openColorModal('page_background_confirmation')">
                                        <label class="typo__label">Background color de pagina</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="page_background_confirmation"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilos de head</h5>
                                    </div>
                                    <div class="col-4" @click="openColorModal('heading_confirmation_background')">
                                        <label class="typo__label">Background head</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="heading_confirmation_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('heading_confirmation_font_color')">
                                        <label class="typo__label">Color de fuente head</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="heading_confirmation_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4">
                                        <label class="typo__label">Font size Head</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="heading_confirmation_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo de subtitulo</h5>
                                    </div>
                                    <div class="col-4" @click="openColorModal('subtitle_confirmation_background')">
                                        <label class="typo__label">Background de subtitulo</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_confirmation_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4" @click="openColorModal('subtitle_confirmation_font_color')">
                                        <label class="typo__label">Color subtitulo</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_confirmation_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4">
                                        <label class="typo__label">Font size subtitulo</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="subtitle_confirmation_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilos textos</h5>
                                    </div>
                                    <div class="col-4"  @click="openColorModal('text_confirmation_background')">
                                        <label class="typo__label">Background texto</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="text_confirmation_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4" @click="openColorModal('text_confirmation_font_color')">
                                        <label class="typo__label">Color de texto</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="text_confirmation_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-4">
                                        <label class="typo__label">Font size de Texto</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="text_confirmation_font_size"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>
                        </tab-content>
                        <tab-content title="Bottom bar" icon="fas fa-file-code"  >
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group" style="padding-top:25px">
                                       
                                        <CInputCheckbox
                                            id="checkbox-3"
                                            v-model="bottom_show"
                                            name="checkbox-3"
                                            label="Mostrar boton"
                                        />
                                        
                                    </div>
                                </div>
                            </div>

                                <div class="row">
                                    <div class="col-12">
                                        <label class="typo__label">
                                            Codigo Html bottom

                                            </label>
                                        <vue-editor v-model="html_code_bottom_bar"></vue-editor>
                                    </div>
                                </div>
                        </tab-content>
                        <tab-content title="CSS bottom" icon="fab fa-css3"  >
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <h5>Estilo General</h5>
                                    </div>
                                    <div class="col-6" @click="openColorModal('bottom_bar_background')">
                                        <label class="typo__label">Background color bottom</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="bottom_bar_background"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                    <div class="col-6"  @click="openColorModal('bottom_bar_font_color')">
                                        <label class="typo__label">Font color bottom</label>
                                        <mdb-input
                                            class="mb-3 mt-0"
                                            v-model="bottom_bar_font_color"
                                            required
                                            invalidFeedback="Coloca el titulo"
                                        >
                                        </mdb-input>
                                    </div>
                                </div>
                        </tab-content>
                    </form-wizard>
            </div>
            <div class="col-5">
                <div v-if="name !== '' && quiz_type !== {} && slug2 !== '' && domain_id !== {} && url_quiz_completion_id !== '' && isFirstPreview">
                      {{createQuiz()}}
                </div>
                <mdb-btn type="button" color="primary" @click="refreshIframe()">
                    <span>Recargar preview</span>
                </mdb-btn>
                <iframe
                v-if="loadPreview"
                :src='Constant.api_path+url_preview'
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                width="100%"
                height="700"
                frameborder="0"
                style="border:0;"
                allowfullscreen=""
                id="iframe-quiz"
                aria-hidden="false"
                tabindex="0"></iframe>
            </div>
        </div>
        <div class="row text-center" v-if="isLoading">
            <semipolar-spinner  :animation-duration="2000" :size="60" color="#ffffff"></semipolar-spinner>
        </div>

  </section>
</template>



<script>
import { SemipolarSpinner } from "epic-spinners";
import colorPicker from '@caohenghu/vue-colorpicker'
import { FormWizard, TabContent } from "vue-form-wizard";
import { VueEditor } from "vue2-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Multiselect from "vue-multiselect";
import Constant from "../../config/const"
import store from "../../store";
import {
  mdbContainer,
  mdbModal,
  mdbModalTitle,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
export default {
  name: "modal-2",
  components: {
    colorPicker,
    Multiselect,
    SemipolarSpinner,
    mdbModalTitle,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip,
    FormWizard,
    TabContent,
    VueEditor
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
        id: '',
        modalImageSelectQuestion: false,
        index_question: 0,
        Constant: Constant,
        url_preview: "",
        loadPreview: false,
        isFirstPreview: true,
        selected_color: '#59c7f9',
        opcionImage: '',
        suckerCanvas: null,
        suckerArea: [],
        isSucking: false,
        modalColor:false,
        isLoading: false,
        is_value_based:false,
        modalBackground:false,
        isLoadingBackground:false,
        modalGallery:false,
        modalGallerySelect:false,
        isLoadingGallery:false,
        background:{
            name:"",
            image:"",
            description:"",
            loader_time:"",
            gallery_ids:[]
        },
        question_types:[
            {value:"multi_choice",name:"Seleccion multiple"},
            {value:"fill_blank",name:"Fill in the Blank"}
        ],
        gallery:{
            title:"",
            image_id:{},
            text_under_image:"",
        },
        questions_gallery_ids:[
            {name:"", page_ids:[],publish:true},
        ],
        quiz_type:{name:"Galeria",value:"gallery"},
        quiz_types:[
            {name:"Galeria",value:"gallery"},
            {name:"Preguntas",value:"questions"},
            {name:"Test",value:"test"}
        ],
        gallery_ids:[],
        questions:[{
            question_text:"",
            image_id:{},
            question_type:"",
            question_options:[]
        }],
        image_ids:[],
        domain_id:{},
        domain_ids:[],
        quiz_model:{name:"Model 1",value:"model1"},
        quiz_models:[
            {name:"Model 1",value:"model1"},
            {name:"Model 2",value:"model2"},
            {name:"Model 3",value:"model3"}
            ],
        name:"",
        partner_id:{},
        partner_ids:[],
        country_id:{},
        country_ids:[],
        subtitle:"",
        slug2:"",
        url_quiz_completion_id:"",
        pre_redirect:false,
        query:"",
        image_id:{},
        loader_images:[],
        loader_images_gallery:[],
        loader_time:"",
        background_img:{},
        background_imgs:[],
        css_page_background:"rgb(255, 255, 255)",
        css_top_bar:"rgb(255, 255, 255)",
        css_top_bar_color:"rgb(0, 0, 0)",
        title_background:"rgba(255,255,255,1)",
        title_font_color:"rgba(46,198,146,1)",
        title_font_size:"28",
        subtitle_font_color:"rgb(204, 204, 179)",
        subtitle_font_size:"28",
        question_background:"rgb(255, 255, 255)",
        question_font_color:"rgb(0, 0, 0)",
        question_font_size: "18",
        option_background:"rgb(0, 0, 0)",
        option_font_color:"rgb(51, 102, 255)",
        option_font_size:"28",
        html_under_answer: "<h1>html</h1>",
        html_head_analytics:`<!-- Google Tag Manager -->
        <   script   >
        (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);})
        (window,document,'script','dataLayer','GTM-TS4Q3XJ');
        </  script   >
        <!-- End Google Tag Manager -->`,
        html_body_analytics:`<!-- Google Tag Manager (noscript) -->
                                <noscript>
                                    <iframe src=https://www.googletagmanager.com/ns.html?id=GTM-TS4Q3XJheight=0 width=0 style=display:none; visibility:hidden></iframe>
                                </noscript>
                                <!-- End Google Tag Manager (noscript) -->`,
        show_confirmation:true,
        heading_confirmation:"Confirma tu respuesta",
        subtitle_confirmation:"",
        text_confirmation:"",
        confirmmation_image_id:{},
        html_code_confirmation:"",
        html_button_code_confirmation:"",
        show_confirmation_last_page:false,
        page_background_confirmation_img:{},
        page_background_confirmation:"rgb(255, 255, 255)",
        heading_confirmation_background:"rgb(46, 198, 146)",
        heading_confirmation_font_color:"rgb(0, 0, 0)",
        heading_confirmation_font_size:"22",
        subtitle_confirmation_background:"rgb(255, 255, 255)",
        subtitle_confirmation_font_color:"rgb(96, 235, 166)",
        subtitle_confirmation_font_size:"27",
        text_confirmation_background:"rgb(0, 0, 0)",
        text_confirmation_font_color:"rgb(255, 255, 255)",
        text_confirmation_font_size:"14",
        bottom_show:false,
        html_code_bottom_bar:"",
        bottom_bar_background:"rgb(46, 198, 146)",
        bottom_bar_font_color:"rgb(255, 255, 255)"
    };
  },
  async mounted(){
    //await this.createTest();
    var test = document.getElementsByClassName("modal-full-height")[0]
    var aside_btn = document.getElementsByClassName("sidebar-minimizer")[0];
    //aside_btn.click();
    // test.style.minWidth = "100%";
    this.isLoading = true
    await this.getImages();
    await this.getWebSites();
    await this.getPartners();
    await this.getCountries();
    await this.getGallerys();
    // await this.getQuizModel();
    this.isLoading = false
  },
  methods: {
    openModalGallery(opcion){
        this.opcionImage = opcion;
        this.modalGallerySelect = true
    },
    openModalGalleryQuestion(index){
        console.log(index+" es el index")
        this.index_question = index;
        this.modalImageSelectQuestion = true;
    },
    changeColor(color) {
        let rgba = color.rgba
        const {r, g, b, a} = rgba
        this[this.selected_color] = `rgba(${r}, ${g}, ${b}, ${a})`
    },
    openSucker(isOpen) {
        if (isOpen) {
            // ... canvas be created
            // this.suckerCanvas = canvas
            // this.suckerArea = [x1, y1, x2, y2]
        } else {
            // this.suckerCanvas && this.suckerCanvas.remove
        }
    },
    openColorModal(opcion) {
        this.selected_color = opcion;
        this.modalColor = true;
    },
    addQuestionGeneral(){
        this.questions.push({
            question_text:"",
            image_id:{},
            question_type:"",
            question_options:[]
        })
    },
    deleteQuestionGeneral(index) {
      this.questions.splice(index, 1)
    },
    onSelectImage(image) {
        this[this.opcionImage] = image;
    },
    onSelectImageQuestion(image) {
        this.questions[this.index_question].image_id = image;
    },
    addQuestion(index){
      this.questions[index].question_options.push({
              question_text:"",
              correct:false,
              value:0
          })
    },
    removeQuestion (index_general,index) {
      this.questions[index_general].question_options.splice(index, 1)
    },
    crearOpcion(index){

    },
    addQuestionGalery(){
        this.questions_gallery_ids.push({name:"", page_ids:[],publish:true})
    },
    deleteQuestionGalery(index){
        this.questions_gallery_ids.splice(index, 1)
    },
    addPage(index){
      this.questions_gallery_ids[index].page_ids.push({
              title:"",
              image_id:{},
              text_under_image:""
          })
    },
    removePage (i,index) {
      this.questions_gallery_ids[index].page_ids.splice(i, 1)
    },
    crearPage(index){
    },
    async getGallerys(){
        var gallery_ids= store.getters.getGallerys;
        if (gallery_ids.length == 0) {
            store.dispatch("getGallerys").then(() => {
                this.gallery_ids = store.getters.getGallerys;
            });
        } else {
            this.gallery_ids = gallery_ids;
        }
    },
    async getWebSites(){
        var domain_ids= store.getters.getWebSites;
        console.log("domain_ids", domain_ids);
        if (domain_ids.length == 0) {
            store.dispatch("getWebSites").then(() => {
            console.log("epaaa")
            this.domain_ids = store.getters.getWebSites;
            console.log(store.getters.getWebSites)
            });
        } else {
            this.domain_ids = domain_ids;
        }
    },
    // async getQuizModel(){
    //     var quiz_model_ids= store.getters.getQuizes;
    //     console.log("quiz_model_ids", quiz_model_ids);
    //     if (quiz_model_ids.length == 0) {
    //         store.dispatch("getQuizModel").then(() => {
    //         console.log("epaaa")
    //         this.quiz_model_ids = store.getters.getQuizes;
    //         console.log("store.getters.getQuizModel :::: ",store.getters.getQuizModel)
    //         });
    //     } else {
    //         this.quiz_model_ids = quiz_model_ids;
    //     }
    // },
    async getPartners(){
      var partner_ids = store.getters.getPartners;
      if (partner_ids.length == 0) {
        await store.dispatch("getPartners").then(() => {
          partner_ids = store.getters.getPartners;
          this.partner_ids = partner_ids;
          return;
        });
      } else {
        this.partner_ids = partner_ids;
        return;
      }
    },
    async getCountries() {
      var country_ids = store.getters.getCountries;
      if (country_ids.length == 0) {
        await store.dispatch("getCountries").then(() => {
          country_ids = store.getters.getCountries;
          this.country_ids = country_ids;
          return;
        });
      } else {
        this.country_ids = country_ids;
        return;
      }
    },
    // async getQuizModel() {
    //   var quiz_model_ids = store.getters.getQuizModel;
    //   if (quiz_model_ids.length == 0) {
    //     await store.dispatch("getQuizModel").then(() => {
    //       quiz_model_ids = store.getters.getQuizModel;
    //       this.quiz_model_ids = quiz_model_ids;
    //       return;
    //     });
    //   } else {
    //     this.quiz_model_ids = quiz_model_ids;
    //     return;
    //   }
    // },

    async getImages(){
        var loader_images= store.getters.getImages
        if (loader_images.length == 0) {
            store.dispatch("getImages").then(() => {
                loader_images = store.getters.getImages;
                let loader_images_gallery = [];
                loader_images.map(image => {
                    loader_images_gallery.push({
                        id: image.id,
                        src: image.image_url,
                        alt: image.name
                    })
                });
                this.loader_images_gallery = loader_images_gallery;
                if(loader_images  == ""){
                    loader_images = []
                }
                this.loader_images = loader_images
            });
        } else {
            this.loader_images = loader_images;
        }
    },
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },
    async previewFiles() {
        const file =  document.getElementById("file-background").files[0];
        this.background.image =  await this.getBase64(file).then(data => {return data});
        this.background.image = this.background.image.split(',')[1]
    },
    crearBackground(e){
        var { background } = this
        this.isLoadingBackground = true;
        store.dispatch("newBackground", background).then(() => {
          this.background = {
            name:"",
            image:"",
            description:"",
            loader_time:"",
            gallery_ids:[]
          }
          this.modalBackground = false
          this.isLoadingBackground = false;
        });
    },
    crearGallery(e){
        var { gallery } = this
        this.isLoadingGallery = true;
        store.dispatch("newGallery", gallery).then(() => {
          this.gallery = {
            title:"",
            image_id:{},
            text_under_image:"",
          }
          this.modalGallery = false
          this.isLoadingGallery = false;
        });

    },
    getQuizData(){
      const {
          id,
          domain_id,
          name,
          quiz_type,
          partner_id,
          country_id,
          subtitle,
          slug2,
          url_quiz_completion_id,
          pre_redirect,
          query,
          image_id,
          loader_time,
          background_img,
          css_page_background,
          css_top_bar,
          css_top_bar_color,
          title_background,
          title_font_color,
          title_font_size,
          subtitle_font_color,
          subtitle_font_size,
          question_background,
          question_font_color,
          question_font_size,
          option_background,
          option_font_color,
          option_font_size,
          html_under_answer,
          html_head_analytics,
          html_body_analytics,
          show_confirmation,
          heading_confirmation,
          subtitle_confirmation,
          text_confirmation,
          confirmmation_image_id,
          html_code_confirmation,
          html_button_code_confirmation,
          show_confirmation_last_page,
          page_background_confirmation_img,
          page_background_confirmation,
          heading_confirmation_background,
          heading_confirmation_font_color,
          heading_confirmation_font_size,
          subtitle_confirmation_background,
          subtitle_confirmation_font_color,
          subtitle_confirmation_font_size,
          text_confirmation_background,
          text_confirmation_font_color,
          text_confirmation_font_size,
          bottom_show,
          html_code_bottom_bar,
          bottom_bar_background,
          bottom_bar_font_color,
          questions_gallery_ids
      } = this

      let questions_galle = [];
      questions_gallery_ids.map(i => {
          questions_galle.push(i.id);
      });
      let questions_arr = [];
      this.questions.map(
          (question, i)=> {
              let ansers = question
                .question_options.map(
                  (option,index)=>`(0,0,{'option':'${option.question_text}','value': ${option.value},'correct': ${(option.correct)?'True':'False'} })`
                );
                questions_arr.push({
                    'image_id': question.image_id.id,
                    'question_options': `[ ${ansers} ]`,
                    'question_text': question.question_text,
                    'question_type': question.question_type.value
                })
          }
      );
      var quiz = {
          id,
          domain_id:domain_id.id,
          name,
          quiz_type:quiz_type.value,
          partner_id:partner_id.id,
          country_id:country_id.id,
          subtitle,
          slug2,
          url_quiz_completion_id,
          pre_redirect,
          query,
          image_id:image_id.id?image_id.id:'',
          loader_time,
          background_img:background_img.id?background_img.id:'',
          css_page_background,
          css_top_bar,
          css_top_bar_color,
          title_background,
          title_font_color,
          title_font_size,
          subtitle_font_color,
          subtitle_font_size,
          question_background,
          question_font_color,
          question_font_size,
          option_background,
          option_font_color,
          option_font_size,
          html_under_answer,
          html_head_analytics,
          html_body_analytics,
          show_confirmation,
          heading_confirmation,
          subtitle_confirmation,
          text_confirmation,
          confirmmation_image_id:confirmmation_image_id.id?confirmmation_image_id.id:'',
          html_code_confirmation,
          html_button_code_confirmation,
          show_confirmation_last_page,
          page_background_confirmation_img: page_background_confirmation_img.id?page_background_confirmation_img.id:'',
          page_background_confirmation,
          heading_confirmation_background,
          heading_confirmation_font_color,
          heading_confirmation_font_size,
          subtitle_confirmation_background,
          subtitle_confirmation_font_color,
          subtitle_confirmation_font_size,
          text_confirmation_background,
          text_confirmation_font_color,
          text_confirmation_font_size,
          bottom_show,
          html_code_bottom_bar,
          bottom_bar_background,
          bottom_bar_font_color,
          questions_gallery_ids:questions_galle,
          questions: questions_arr
      }
      return quiz
    },
    onComplete(event) {
      let quiz = this.getQuizData()
      store.dispatch("editQuiz", quiz).then(() => {
          this.name=""
          this.onClick();
          this.isLoading = false;
      });
    },
    createQuiz(){
        this.isFirstPreview = false
        store.dispatch("newQuizPreview", {
            name: this.name,
            quiz_type: this.quiz_type.value,
            slug2: this.slug2,
            url_quiz_completion_id: this.url_quiz_completion_id,
            domain_id: this.domain_id.id
            }).then((res) => {
                this.id = store.getters.getIdPreview;
                var response = store.getters.getQuizPreviewResponse;
                if( response.success ){
                    this.loadPreview = true
                    this.url_preview = response.response.url;
                }
        });
        return ""
    },
    async refreshIframe(){
        if(this.id !== ''){
            const quiz = this.getQuizData();
            await store.dispatch("editQuiz", quiz)
            await store.dispatch("refreshQuiz", this.id)
            this.isLoading = false;
            const iframe = document.getElementById('iframe-quiz');
            iframe.src = iframe.src;
        }

    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.hu-color-picker {
    background: #4285f4 !important;
}
</style>